import { BehaviorSubject } from 'rxjs/BehaviorSubject';

export class TitlesService {
  breadcrumbs = new BehaviorSubject(null);

  get breadcrumbs$() {
    return this.breadcrumbs.asObservable();
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/visual/titles.service.ts